import { HttpClient } from "app/core/http";

export class BaseService {
    protected httpClient!: HttpClient;

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }
}
